import LivePage from './LivePage'

export default LivePage
// eslint-disable-next-line import/export
export * from './LivePage'
